import { BASE_URL } from 'config';
// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import AddUserModal from "components/AddUserModal";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
export default function hestoricPlaceTableData(eventCategory, handleEditClick, fetchEventCategory) {
  const handleDeletion = async (eventCategory) => {
    // رسالة تأكيد احترافية
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف المكان التاريخي "${eventCategory.name}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      customClass: {
        title: "text-danger",
        confirmButton: "btn btn-danger mx-2",
        cancelButton: "btn btn-secondary mx-2",
      },
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("user-token");
          const response = await axios.get(
            `${BASE_URL}/historical-places/delete/${eventCategory.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    // معالجة النتيجة
    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف المكان التاريخي بنجاح",
        });
        fetchEventCategory();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };
  const Name = ({ name, image }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar
        src={image}
        name={name}
        size="sm"
        sx={{
          // 1. الخلفية الرمادية عند عدم وجود صورة
          backgroundColor: !image ? "grey.300" : "rgba(0, 0, 0, 0)",
          // 2. تحديد الحجم الجديد
          width: 40,
          height: 40,
          // 3. التأكد من الشكل الدائري
          borderRadius: "50%",
          // 4. تنسيق محتوى الأيقونة
          "& .MuiSvgIcon-root": {
            fontSize: "1rem", // تكبير حجم الأيقونة
          },
        }}
      >
        {!image && <PersonIcon fontSize="small" />}
      </MDAvatar>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
  return {
    columns: [
      { Header: "الاسم", accessor: "name", width: "30%", align: "left" },
      { Header: "الفئة", accessor: "place_category", align: "left" },
      { Header: "الوصف", accessor: "description", width: "30%", align: "left" },
      { Header: "التمييز", accessor: "is_featured", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],

    rows: eventCategory.map((eventCategory) => ({
      name: (
        <Name
          name={eventCategory.name}
          image={eventCategory.main_image ? eventCategory.main_image : null}
        />
      ),
      place_category: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {eventCategory.place_category?.name}
        </MDTypography>
      ),
      description: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {eventCategory.description && eventCategory.description.length > 50
            ? eventCategory.description.slice(0, 50) + "..."
            : eventCategory.description}
        </MDTypography>
      ),
      is_featured: (
        <MDTypography
          variant="caption"
          fontWeight="bold"
          sx={{
            color: eventCategory.is_featured ? "#FFD600" : "#d32f2f",
            background: eventCategory.is_featured
              ? "rgba(255, 214, 0, 0.1)"
              : "rgba(211, 47, 47, 0.1)",
            borderRadius: "8px",
            px: 2,
            py: 0.5,
            display: "inline-block",
            minWidth: 60,
            textAlign: "center",
          }}
        >
          {eventCategory.is_featured ? "مميز" : "غير مميز"}
        </MDTypography>
      ),
      action: (
        <MDBox
          display="flex"
          alignItems="center"
          gap={1}
          p={1}
          borderRadius="lg"
          bgcolor="background.paper"
          boxShadow={1}
        >
          <IconButton
            aria-label="edit"
            sx={{
              color: "text.main",

            }}
            onClick={() => handleEditClick(eventCategory)}
          >
            <EditIcon fontSize="medium" />
          </IconButton>

          <IconButton
            aria-label="delete"
            sx={{
              color: "error.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleDeletion(eventCategory)}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
